module.exports = __webpack_public_path__ + "img/user.f4d3625e.svg";